var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class OrdersManager {
    constructor() {
        this.selected_orders = [];
    }
    construct() {
        this.selected_orders = [];
        console.log("Orders Manager initialized");
    }
    // Aggiorna array selected orders
    updateSelectedOrders(element) {
        let selected_orders = this.selected_orders;
        let order_number = $(element).val();
        if ($(element).prop("checked")) {
            selected_orders.push(order_number);
        }
        else {
            $.each(selected_orders, function (index, value) {
                if (value === order_number) {
                    selected_orders.splice(index, 1);
                }
            });
        }
        var n = selected_orders.length;
        $('#selector_status').html("Selezionati " + n + " ordini");
        // Update actions button
        // Se ordini selazionati > 0 attiva pulsante        
        if (n > 0) {
            $('.btn-action').prop("disabled", false);
            // Se tra gli ordini selezionati ci sono ordini spediti
            // non permetto le modifiche dello stato dell'ordine 
            // tranne l'annullamento e la rimozione definititva
            var deselect_status_change = 0;
            selected_orders.forEach(on => {
                if ($(".order-" + on).data('order_status') === "S") {
                    deselect_status_change = 1;
                }
            });
            if (deselect_status_change) {
                $('.btn-action.btn-status')
                    .not('[data-status="cancelled"]')
                    .not('[data-status="remove"]')
                    .prop("disabled", true);
            }
        }
        else {
            $('.btn-action').prop("disabled", true);
        }
        // Disabilita azioni che funzionano solo su un'ordine alla volta
        if (n > 1) {
            $('.btn-edit-tracking-number').prop("disabled", true);
            $('.btn-edit-orderdata').prop("disabled", true);
            $('.btn-stato-pagamento').prop("disabled", true);
            $('.btn-refund-order').prop("disabled", true);
            $('.btn-crea-fattura').prop("disabled", true);
            $('.btn-check-voucher-docente').prop("disabled", true);
        }
        this.selected_orders = selected_orders;
        return true;
    }
    // Stampa array selected orders    
    printout() {
        console.log(this.selected_orders);
    }
    showUpdateOrderStatus(element) {
        var new_order_status = $(element).data('status');
        var action_url = 'core/ajax/processOrderData.php';
        var pthis = this;
        var n = this.selected_orders.length;
        if (new_order_status && n > 0) {
            var $message_container = $('#general_messages.message_container');
            $.ajax({
                type: 'POST',
                url: action_url,
                data: {
                    button: "showupdatestatus",
                    new_order_status: new_order_status,
                    selected_orders: this.selected_orders
                },
                success: function (response) {
                    var jresponse = JSON.parse(response);
                    if (jresponse.status == "success") {
                        $("#modal-wrap").html("");
                        $("#modal-wrap").html(jresponse.modal);
                        // Clean backdrop
                        $(".modal-backdrop").remove();
                        // Show modal
                        $('#editOrderStatus').modal('show');
                        $("#p-save-update-status").on('click', function () {
                            let sub_selected_orders_array = $("#form-order-status").serializeArray();
                            let sub_selected_orders = [];
                            let notify_customer = 0;
                            let update_stock = 1;
                            sub_selected_orders_array.forEach((so) => {
                                if (so.name == 'order_number') {
                                    let order_number = so.value;
                                    // Check set to ship for this order number
                                    let include_this_order = false;
                                    include_this_order = $("#include_this_order-" + order_number).is(':checked');
                                    if (include_this_order) {
                                        sub_selected_orders.push(order_number);
                                    }
                                }
                                else if (so.name === "updateStockCheck") {
                                    if (so.value === "on") {
                                        update_stock = 1;
                                    }
                                    else {
                                        update_stock = 0;
                                    }
                                }
                                else if (so.name === "notifyCustomer") {
                                    if (so.value === "on") {
                                        notify_customer = 1;
                                    }
                                    else {
                                        notify_customer = 0;
                                    }
                                }
                            });
                            // Debug =============
                            // console.log(sub_selected_orders_array);
                            // console.log("notify_customer "+notify_customer);
                            // console.log("update_stock "+update_stock);                            
                            // console.log("new_order_status "+new_order_status);
                            // console.log(sub_selected_orders);                            
                            // Debug =============
                            pthis.updateOrdersStatus(sub_selected_orders, new_order_status, notify_customer, update_stock);
                        });
                    }
                    // In ogni caso faccio comparire messsaggio di stato
                    $message_container.html(jresponse.statusMsg);
                },
            });
        }
    }
    // Ajax call per modificare status ordini
    updateOrdersStatus(selected_orders, new_order_status, notify_customer = 0, update_stock = 1) {
        var action_url = 'core/ajax/processOrderData.php';
        var n = selected_orders.length;
        if (new_order_status && n > 0) {
            var $message_container = $('.modal-footer .message_container');
            $.ajax({
                type: 'POST',
                url: action_url,
                data: {
                    button: "updatestatus",
                    new_order_status: new_order_status,
                    selected_orders: selected_orders,
                    notify_customer: notify_customer,
                    update_stock: update_stock
                },
                beforeSend: function () {
                    $("#p-save-update-status").hide();
                    $("#loader_container").show();
                },
                success: function (response) {
                    var jresponse = JSON.parse(response);
                    if (jresponse.status == "success") {
                        // Redirect                        
                        window.location.href = "index.php?type=tnt";
                    }
                    else {
                        $("#p-save-update-status").show();
                        $message_container.html('ERROR: ' + jresponse.statusMsg);
                    }
                    $("#loader_container").hide();
                },
            });
        }
    }
    // Ajax call per generare ricevute (fatture di cortesia) ordini
    generateOrderReceipt(element) {
        var action_url = 'core/ajax/processOrderData.php';
        var n = this.selected_orders.length;
        if (n > 0) {
            var $message_container = $('#general_messages.message_container');
            $.ajax({
                type: 'POST',
                url: action_url,
                data: {
                    button: "ricevuta",
                    selected_orders: this.selected_orders
                },
                success: function (response) {
                    var jresponse = JSON.parse(response);
                    console.log(jresponse);
                    if (jresponse.status == "success") {
                        // Redirect
                        // window.location = "index.php?type=tnt";
                    }
                    // In ogni caso faccio comparire messsaggio di stato
                    $message_container.html(jresponse.statusMsg);
                },
            });
        }
    }
    // Ajax call per generare DDT ordini
    generateOrderDDT(element) {
        var action_url = 'core/ajax/processOrderData.php';
        var n = this.selected_orders.length;
        if (n > 0) {
            var $message_container = $('#general_messages.message_container');
            $.ajax({
                type: 'POST',
                url: action_url,
                data: {
                    button: "ddt",
                    selected_orders: this.selected_orders
                },
                success: function (response) {
                    var jresponse = JSON.parse(response);
                    console.log(jresponse);
                    if (jresponse.status == "success") {
                        // Redirect
                        // window.location = "index.php?type=tnt";
                    }
                    // In ogni caso faccio comparire messsaggio di stato
                    $message_container.html(jresponse.statusMsg);
                },
            });
        }
    }
    // Ajax call Modifica le spese di spedizione dell'ordine (toglie/mette)
    toggleShipping(element) {
        var action_url = 'core/ajax/processOrderData.php';
        var n = this.selected_orders.length;
        if (n > 0) {
            var $message_container = $('#general_messages.message_container');
            $.ajax({
                type: 'POST',
                url: action_url,
                data: {
                    button: "toggleshipping",
                    selected_orders: this.selected_orders
                },
                success: function (response) {
                    var jresponse = JSON.parse(response);
                    // console.log(jresponse);
                    if (jresponse.status == "success") {
                        // Redirect
                        window.location.href = "index.php?type=tnt";
                    }
                    // In ogni caso faccio comparire messsaggio di stato
                    $message_container.html(jresponse.statusMsg);
                },
            });
        }
    }
    // Ajax call Modifica ordine da privato a PA
    setorderasPA(element) {
        var action_url = 'core/ajax/processOrderData.php';
        var n = this.selected_orders.length;
        if (n > 0) {
            var $message_container = $('#general_messages.message_container');
            $.ajax({
                type: 'POST',
                url: action_url,
                data: {
                    button: "setorderaspa",
                    selected_orders: this.selected_orders
                },
                success: function (response) {
                    var jresponse = JSON.parse(response);
                    // console.log(jresponse);
                    if (jresponse.status == "success") {
                        // Redirect
                        window.location.href = "index.php?type=tnt";
                    }
                    // In ogni caso faccio comparire messsaggio di stato
                    $message_container.html(jresponse.statusMsg);
                },
            });
        }
    }
    // Mostra ordine as modal window
    showEditTrackingNumber() {
        let pthis = this;
        let action_url = 'core/ajax/processOrderData.php';
        let order_number = this.selected_orders[0];
        if (order_number) {
            $.ajax({
                type: 'POST',
                url: action_url,
                data: {
                    button: "showedittrackingnumber",
                    order_number: order_number
                }
            })
                .done(function (response) {
                var jresponse = JSON.parse(response);
                // console.log(jresponse)             
                if (jresponse.status == "success") {
                    $("#modal-wrap").html("");
                    $("#modal-wrap").html(jresponse.modal);
                    // Clean backdrop
                    $(".modal-backdrop").remove();
                    // Show modal
                    $('#editTrackingNumber').modal('show');
                    pthis.bindUpdateTrackingNumber();
                }
            })
                .fail(function (response) {
                alert('failed');
            });
        }
        return 1;
    }
    /**
     * Vai alla view per inviare
     * le mail per chiedere il voucher della carta docente
     *
     * @returns bool
     */
    gotoBatchSendRequestVoucher() {
        let ons = "";
        this.selected_orders.forEach(el => {
            if (ons === "") {
                ons = el.toString();
            }
            else {
                ons = ons + ";" + el.toString();
            }
        });
        location.href = "index.php?type=carta_del_docente&view=sendbatchemails&ons=" + ons;
    }
    /**
     * Vai alla view per inviare
     * recensioni in batch per gli ordini selezionati
     *
     * @returns bool
     */
    gotoBatchSendReviews() {
        let ons = "";
        this.selected_orders.forEach(el => {
            if (ons === "") {
                ons = el.toString();
            }
            else {
                ons = ons + ";" + el.toString();
            }
        });
        location.href = "index.php?type=testimonials&view=sendbatchreviews&ons=" + ons;
    }
    goToSetStatoPagamento() {
        let order_number = this.selected_orders[0];
        let orderid = $('.order-' + order_number).data('virtuemart_order_id');
        location.href = "index.php?type=tnt&view=stato_pagamento&order_id=" + orderid;
    }
    goToEditOrder() {
        let order_number = this.selected_orders[0];
        let orderid = $('.order-' + order_number).data('virtuemart_order_id');
        location.href = "index.php?type=tnt&view=edit&order_id=" + orderid;
    }
    goToRefund() {
        let order_number = this.selected_orders[0];
        let orderid = $('.order-' + order_number).data('virtuemart_order_id');
        location.href = "index.php?type=resi&orid=" + orderid;
    }
    goToCheckVoucher() {
        let order_number = this.selected_orders[0];
        location.href = "index.php?type=carta_del_docente&view=check-voucher&order_number=" + order_number;
    }
    gotToCreaFattura() {
        let order_number = this.selected_orders[0];
        location.href = "index.php?type=invoicesnew&view=edit&order_number=" + order_number;
    }
    preLoadProds() {
        return __awaiter(this, void 0, void 0, function* () {
            const action_url = '/core/ajax/ajax_request_product_fewdata.php';
            return yield $.ajax({
                type: 'POST',
                url: action_url,
                data: {
                    button: "fewdata"
                }
            });
            // .done(function(response) {   
            //     let jresponse = JSON.parse(response);     
            //     // console.log(jresponse);           
            // });
        });
    }
    bindAutocompleteNameEditOrder() {
        this.preLoadProds().then((response) => {
            let plist_names = JSON.parse(response).plist;
            $('.order_item_name').on('click', function () {
                // Append to parent of input!! Altrimenti se appendo a input stesso non funziona            
                // let id = '#'+$(this).parent().attr('id');            
                let $parent = $(this).parent();
                $('.order_item_name').autocomplete({
                    appendTo: $(this).parent(),
                    source: plist_names,
                    select: function (event, ui) {
                        // console.log(ui.item);
                        $parent.find(".product_iva").val(22);
                        $parent.find(".product_final_price").val(ui.item.price);
                        $parent.find(".virtuemart_product_id").val(ui.item.pid);
                    }
                });
            });
        });
    }
    /**
     * Funzione per salvare modifiche ordine
     * OBSOLETE
     * Rimpiazzata da js in tnt/views/edit.php
     *
     *  */
    bindButtonSaveEditOrderData() {
        // $( "#edit-orderdata-form" ).on( "submit", function( event ) {
        // event.preventDefault();
        // console.log( $( this ).serialize() );
        // });
        $(".button-save-edit-orderdata").on('click', function () {
            var soquellochefaccio = $('#soquellochefaccio').is(":checked");
            var userdata = $("#userdata-fields :input").serializeArray();
            var itemsdata = $("#order-items-fields :input").serializeArray();
            var ordersummarydata = $("#order-summary-fields :input").serializeArray();
            var virtuemart_paymentmethod_id = $("#virtuemart_paymentmethod_id").val();
            var orderid = $(this).data("orderid");
            var action_url = 'core/ajax/processOrderData.php';
            if (soquellochefaccio) {
                $.ajax({
                    type: 'POST',
                    url: action_url,
                    data: {
                        button: "store",
                        userdata: userdata,
                        itemsdata: itemsdata,
                        ordersummarydata: ordersummarydata,
                        virtuemart_paymentmethod_id: virtuemart_paymentmethod_id,
                        orderid: orderid
                    },
                    success: function (response) {
                        var jresponse = JSON.parse(response);
                        console.log(jresponse);
                        if (jresponse.status == "success") {
                            // Se sono nella finestra modale faccio sparire pulsante e metto messaggio inviato
                            $("#message_container").html("Saved!");
                            $("#edit-orderdata-form").hide();
                            // Redirect
                            // window.location = "index.php?type=tnt";
                        }
                        // In ogni caso faccio comparire messsaggio di stato
                        $("#message_container").html(jresponse.statusMsg);
                        // $(message_container).html(jresponse.tntReturnXml);                   
                    },
                });
            }
            else {
                console.log("ERROR");
                $("#message_container").html("Non hai flaggato il checkbox in alto: \"so quello che sto facendo\". Ti sei dimenticato oppure non sai quello che stai facendo!?!?");
            }
        });
    }
    pad(n, width, z = '0') {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }
    // Formatta numero in base alle specifiche del xml del corriere 
    formatNumber(number, lead, digits, courier) {
        let pthis = this;
        let numberf = "";
        if (courier == "tnt") {
            let nstr = number.toString();
            let weightsplit = nstr.split('.');
            let a = "";
            let b = "";
            if (weightsplit.length > 1) {
                a = pthis.pad(weightsplit[0], lead);
                if (digits == 3) {
                    b = weightsplit[1].substr(0, 1) + "00";
                }
                else if (digits == 2) {
                    b = weightsplit[1].substr(0, 1) + "0";
                }
                numberf = a + b;
            }
            else {
                numberf = nstr;
            }
        }
        return numberf;
    }
    // Dati relativi ai pacchetti contenuti nella spedizione
    getPackInfo(orderid, courier) {
        let pthis = this;
        let parameters = {};
        // // Pacakges
        let pack_n = 1;
        let length = 20;
        let height = 20;
        let width = 20;
        let quantity = 1;
        let weight = 1;
        let itemtype = "C";
        let packages = [];
        let packages_container = $("#order-" + orderid + " .package-n");
        $(packages_container).each(function (i, obj) {
            length = parseFloat($(this).find('.length').val());
            height = parseFloat($(this).find('.height').val());
            width = parseFloat($(this).find('.width').val());
            quantity = parseFloat($(this).find('.quantity').val());
            weight = parseFloat($(this).find('.weight').val());
            itemtype = $(this).find('.package-selector').val();
            // console.log(obj);
            pack_n = i + 1;
            let package_i = {};
            if (!length)
                length = 20;
            package_i.length_raw = length;
            package_i.length = pthis.formatNumber(length, 3, 3, courier);
            if (!height)
                height = 20;
            package_i.height_raw = height;
            package_i.height = pthis.formatNumber(height, 3, 3, courier);
            if (!width)
                width = 20;
            package_i.width_raw = width;
            package_i.width = pthis.formatNumber(width, 3, 3, courier);
            if (!quantity)
                quantity = 1;
            package_i.quantity_raw = quantity;
            package_i.quantity = quantity;
            // Weight format NNNNNddd
            if (!weight)
                weight = 1;
            package_i.weight_raw = weight;
            package_i.weight = pthis.formatNumber(weight, 5, 3, courier);
            // C = colli, S = buste /             
            package_i.itemtype = itemtype;
            // Set some default values
            package_i.itemsequenceno = pack_n;
            package_i.itemreference = "Giocattoli";
            packages.push(package_i);
        });
        parameters.packagetype = itemtype;
        parameters.packages = packages;
        parameters.totalpackages = pack_n;
        return parameters;
    }
    glsPriceInterpolation(volume) {
        let price = 0.0;
        // if (volume > 100000) {
        // Linear regime > 30 kg peso volume (vol 100000 cm^3)
        //   price = -21.09 + volume * 3.469e-4;
        //} else {
        // Stepfunction
        const vols = [0, 9999, 33330, 66660, 99990, 166650];
        const prices = [4.5, 7.1, 9.0, 12.2, 16.6];
        const closest = vols.reduce((a, b) => {
            return volume > a && volume <= b ? a : b;
        });
        // console.log(closest);
        let vindex = vols.findIndex((element) => element == closest);
        price = prices[vindex] * 1.22;
        //}
        return (price);
    }
    tntPriceInterpolation(volume) {
        let price = 0.0;
        if (volume > 120000) {
            // Linear regime 
            price = -18.73 + volume * 0.000238;
        }
        else {
            // Stepfunction
            const vols = [0, 20000, 40000, 80000, 120000];
            const prices = [6.6, 8.38, 9.38, 10.62];
            const closest = vols.reduce((a, b) => {
                return volume > a && volume <= b ? a : b;
            });
            // console.log(closest)
            let vindex = vols.findIndex((element) => element == closest);
            price = prices[vindex] * 1.22;
        }
        return (price);
    }
    // Calcolo del peso volume e comparo con peso reale
    volumeWeightCheck(orderid) {
        let pthis = this;
        let parameters = pthis.getPackInfo(orderid, "");
        let total_real_weight = 0;
        let total_volume_weight_gls = 0;
        let total_volume_weight_tnt = 0;
        let total_volume = 0;
        for (let i in parameters.packages) {
            let package_i = parameters.packages[i];
            total_real_weight += package_i.weight_raw;
            let volume = package_i.length_raw * package_i.height_raw * package_i.width_raw;
            total_volume += volume;
            total_volume_weight_gls = total_volume_weight_gls + package_i.quantity_raw * (volume / 3333.0);
            total_volume_weight_tnt = total_volume_weight_tnt + package_i.quantity_raw * (volume / 4000.0);
            // Se buste override total_volume_weight contotal_real_weight
            if (package_i.itemtype == "S") {
                total_volume_weight_gls = total_real_weight;
                total_volume_weight_tnt = total_real_weight;
            }
        }
        let tnt_price = pthis.tntPriceInterpolation(total_volume);
        let gls_price = pthis.glsPriceInterpolation(total_volume);
        let weights = { "total_real_weight": total_real_weight, "total_volume_weight_gls": total_volume_weight_gls, "total_volume_weight_tnt": total_volume_weight_tnt, "tnt_price": tnt_price, "gls_price": gls_price };
        return weights;
    }
    reloadPreventivi(orderid) {
        let $preventivi_corriere_container = $('#order-' + orderid).find(".preventiviCarrier-results-table");
        let action_url = 'core/ajax/shipmentPriceCheck.php';
        $.ajax({
            type: 'POST',
            url: action_url,
            data: {
                button: "reloadpreventivi",
                orderid: orderid
            }
        }).done(function (response) {
            let jresponse = JSON.parse(response);
            // console.log(jresponse)  
            $preventivi_corriere_container.html(jresponse.html);
        });
    }
    shipmentPriceCheck(orderid) {
        let $price_container = $('#order-' + orderid).find(".checkBestCarrier-results-prices");
        $price_container.html("");
        let $loader_container = $("#loader-prices-wrap-" + orderid);
        let pthis = this;
        let action_url = 'core/ajax/shipmentPriceCheck.php';
        let package_data = {};
        package_data = pthis.getPackInfo(orderid, "");
        if (orderid) {
            $.ajax({
                type: 'POST',
                url: action_url,
                data: {
                    button: "pricecheck",
                    orderid: orderid,
                    package_data: package_data
                },
                beforeSend: function () {
                    $loader_container.show();
                }
            }).done(function (response) {
                let jresponses = JSON.parse(response);
                console.log(jresponses);
                for (let i = 0; i < jresponses.length; i++) {
                    let jresponse = jresponses[i];
                    if (jresponse.status != "success") {
                        $price_container.prepend('<div>' + jresponse.statusMsg + '</div>');
                    }
                    else {
                        if (parseFloat(jresponse.price) > 0) {
                            // $price_container.prepend('<div>Prezzo '+jresponse.courier.toUpperCase()+' '+jresponse.price+' <small>IVA inclusa. Solo consegna domicilio. Contrassegno escluso.</small></div>');
                            // Reload preventivi
                            pthis.reloadPreventivi(orderid);
                        }
                    }
                }
                $loader_container.hide();
            }).fail(function (response) {
                alert('failed');
            });
        }
    }
    // Suggerimento quale corriere utilizzare 
    bindCheckBestCarrier() {
        let pthis = this;
        $(".checkBestCarrier").on('click', function (el) {
            let orderid = $(this).data('orderid');
            let $results_container = $('#order-' + orderid).find(".checkBestCarrier-results");
            let weights = pthis.volumeWeightCheck(orderid);
            console.log(weights);
            if (weights) {
                let corriere_suggerito = "tnt";
                // if (Math.max(weights.total_real_weight, weights.total_volume_weight) < 3 ) {
                if (weights.gls_price < weights.tnt_price) {
                    corriere_suggerito = "gls";
                }
                $results_container.html('<div>Peso reale totale: ' + weights.total_real_weight.toFixed(2) + ' kg</div> <div>Peso volume totale (tnt): ' + weights.total_volume_weight_tnt.toFixed(2) + ' kg</div><div>Peso volume totale (gls): ' + weights.total_volume_weight_gls.toFixed(2) + ' kg</div> <div>Prezzo tnt (con IVA): ' + weights.tnt_price.toFixed(2) + ' Eur</div> <div>Prezzo gls (con IVA): ' + weights.gls_price.toFixed(2) + ' Eur</div> <div>Corriere suggerito: ' + corriere_suggerito.toUpperCase() + '</div>');
            }
        });
    }
    // Qutazione spedizione con corrieri
    bindCheckPriceCarriers() {
        let pthis = this;
        $(".checkPriceCarriers").on('click', function (el) {
            let orderid = $(this).data('orderid');
            pthis.shipmentPriceCheck(orderid);
        });
    }
    // Funzione per aggiungere e rimuovere prodotti
    bindAddRemoveProductsFromEditOrder() {
        $(".add-products").click(function (i, el) {
            // var p1 = $(this).parent().parent().find(".package-n");
            let number_of_existing_prods = $(this).parent().parent().parent().find(".product-n").length;
            // var orderid = $(this).parent().parent().find(".package-n").eq(0).data("orderid");            
            let prod_n = number_of_existing_prods + 1;
            // Clone first element
            let p1 = $(this).parent().parent().parent().find(".product-n").eq(0).clone(true, true);
            // Set data attributes to default values
            $(p1).attr("data-itemn", prod_n);
            $(p1).find(".order_item_name").val("Nome prodotto");
            $(p1).find(".product_final_price").val(0.0);
            $(p1).find(".virtuemart_product_id").val(-prod_n);
            // Append to container
            let container = $(this).parent().parent().parent();
            $(container).append(p1);
        });
        $(".remove-products").click(function (i, el) {
            let number_of_existing_prods = $(this).parent().parent().parent().find(".product-n").length;
            if (number_of_existing_prods > 1) {
                // Last item
                // p = $("div[data-itemn='"+number_of_existing_prods+"']");
                // Selected item
                let p = $(this).parent().parent();
                $(p).fadeOut(300, function () { $(this).remove(); });
            }
        });
    }
    bindUpdateTrackingNumber() {
        $("#p-save-tracking").on("click", function () {
            let action_url = 'core/ajax/processOrderData.php';
            let tracking_rt = $(".tracking_rt_edit").val();
            let courier = $(".courier_edit").val();
            let virtuemart_order_id = $(".virtuemart_order_id").val();
            // console.log(tracking_rt);
            // console.log(courier);
            if (tracking_rt && courier) {
                $.ajax({
                    type: 'POST',
                    url: action_url,
                    data: {
                        button: "updatetrackingnumber",
                        virtuemart_order_id: virtuemart_order_id,
                        tracking_rt: tracking_rt,
                        courier: courier
                    }
                })
                    .done(function (response) {
                    var jresponse = JSON.parse(response);
                    // console.log(jresponse)             
                    if (jresponse.status == "success") {
                        $("#p-save-tracking").hide();
                        $(".message_container").html(jresponse.statusMsg);
                        window.location.reload();
                    }
                })
                    .fail(function (response) {
                    alert('failed');
                });
            }
            else {
                $(".message_container").html("Devi specificare lettera di vettura e corriere.");
            }
        });
    }
    // Mostra ordine as modal window
    showOrderAsModal(order_id) {
        var action_url = 'core/ajax/processOrderData.php';
        // if (order_id) {
        return $.ajax({
            type: 'POST',
            url: action_url,
            data: {
                button: "showorder",
                order_id: order_id,
                format: "modal"
            }
        })
            .done(function (response) {
            var jresponse = JSON.parse(response);
            // console.log(jresponse)             
            if (jresponse.status == "success") {
                $("#modal-wrap").html("");
                $("#modal-wrap").html(jresponse.modal);
                // Clean backdrop
                $(".modal-backdrop").remove();
                // Show modal
                $('#modalOrder').modal('show');
            }
        })
            .fail(function (response) {
            alert('failed');
        });
        // }
        // return 1;
    }
    /**
     *  Mostra ordine in a div
     *  e binding di eventi
     *
     *  */
    showOrderInDiv(order_id, div_id, parameters) {
        let pthis = this;
        var action_url = 'core/ajax/processOrderData.php';
        // if (order_id) {
        return $.ajax({
            type: 'POST',
            url: action_url,
            data: {
                button: "showorder",
                order_id: order_id,
                format: "plain",
                parameters: parameters
            }
        })
            .done(function (response) {
            var jresponse = JSON.parse(response);
            if (jresponse.status == "success") {
                // console.log(jresponse);
                //$("#"+div_id).html("");
                $("#" + div_id).html(jresponse.modal);
                // Info su ordini successivi/precenti. Mi serve solo 
                // per disabilitare pulsante successivo o precedente
                $(".next-prev-right-stuff.next_order_arrow").show();
                $(".next-prev-right-stuff.prev_order_arrow").show();
                let next_order_id = parseFloat($("#order-w-" + order_id).attr('data-next_order'));
                let prev_order_id = parseFloat($("#order-w-" + order_id).attr('data-prev_order'));
                if (next_order_id == -1)
                    $(".next-prev-right-stuff.next_order_arrow").hide();
                if (prev_order_id == -1)
                    $(".next-prev-right-stuff.prev_order_arrow").hide();
                $(function () {
                    pthis.bindCheckBestCarrier();
                });
                $(function () {
                    pthis.bindCheckPriceCarriers();
                });
                // Product package status        
                $('.dettaglio-prodotti').on('post-body.bs.table', function (e) {
                    pthis.bindUpdateProductPackageStatus(this.id);
                });
                // OBSOLETE
                pthis.bindButtonEditReviewEmail();
                var orders_labels_obj = new OrdersLabels();
                orders_labels_obj.packageSelector();
                orders_labels_obj.addMorePackages();
                orders_labels_obj.bindRemovePackage(order_id);
                orders_labels_obj.reorderPackages(order_id);
                orders_labels_obj.createLabel();
                orders_labels_obj.editLabel();
            }
        });
        // }        
    }
    /**
     * OBSOLETE
     * Mostra finestra modale per editare e inviare
     * una recensione per un singolo ordine
     *
     */
    bindButtonEditReviewEmail() {
        let self = this;
        $(".edit-review-email").on('click', function (el) {
            el.preventDefault(); // Sono link quindi metto prevent
            var button = $(this).parent().parent().find(".button-send-review");
            var reviewbuttonid = $(button).attr('id');
            var orderid = $(button).data('orderid');
            var order_number = $(button).data('order_number');
            var email = $(button).data('email');
            var first_name = $(button).data('first_name');
            var action_url = 'core/ajax/sendReviewEmail.php';
            var message_container = "#order-" + orderid + " .card-footer .message-container";
            if (email) {
                $.ajax({
                    type: 'POST',
                    url: action_url,
                    data: {
                        button: "edit",
                        email: email,
                        first_name: first_name,
                        order_number: order_number
                    },
                    success: function (response) {
                        var jresponse = JSON.parse(response);
                        if (jresponse.status == "success") {
                            // $(stato_fattura).html("Recensione inviata");
                            // $("#"+buttonid).parent().hide();
                            // Fill in modal (clear first)
                            $("#modal-wrap").html("");
                            $("#modal-wrap").html(jresponse.modal);
                            self.bindButtonSendReviewEmail(reviewbuttonid);
                            // Clean backdrop
                            $(".modal-backdrop").remove();
                            // Show modal
                            $('#modalEditReviewMail').modal('show');
                        }
                        // console.log(jresponse);
                        $(message_container).html(jresponse.statusMsg);
                        // $(message_container).html(jresponse.tntReturnXml);                   
                    },
                });
            }
        });
    }
    /**
     * OBSOLETE
     * Invia la singola richiesta di recensione
     * dal dropdown del singolo ordine
     *
     *  */
    bindButtonSendReviewEmail(reviewbuttonid) {
        $(".button-send-review").on('click', function () {
            var buttonid = $(this).attr('id');
            var orderid = $(this).data('orderid');
            var order_number = $(this).data('order_number');
            var email = $(this).data('email');
            var message = $("#reviewTextArea").val();
            var first_name = $(this).data('first_name');
            var action_url = 'core/ajax/sendReviewEmail.php';
            // var message_container = "#order-" + orderid + " .card-footer";
            if (email) {
                $.ajax({
                    type: 'POST',
                    url: action_url,
                    data: {
                        button: "send",
                        email: email,
                        first_name: first_name,
                        order_number: order_number,
                        message: message
                    },
                    success: function (response) {
                        var jresponse = JSON.parse(response);
                        // console.log(jresponse);
                        if (jresponse.status == "success") {
                            // $(stato_fattura).html("Recensione inviata");
                            $("#" + buttonid).parent().hide();
                            // Se sono nella finestra modale faccio sparire pulsante e metto messaggio inviato
                            $("#message_container").html("Inviata!");
                            $("#edit-review-email-form").hide();
                            // Nascondi anche il pulsante dropdown da cui ho aperto la modal
                            $("#" + reviewbuttonid).parent().hide();
                        }
                        // In ogni caso faccio comparire messsaggio di stato
                        $("#message_container").html(jresponse.statusMsg);
                        // $(message_container).html(jresponse.tntReturnXml);                   
                    },
                });
            }
        });
    }
    bindUpdateProductPackageStatus(id) {
        var pthis = this;
        $('#' + id + ' .product_package_status, #' + id + ' .product_package_id').on('change', function () {
            let parameters = {};
            parameters.virtuemart_order_id = $(this).closest('table').data('virtuemart_order_id');
            parameters.virtuemart_product_id = $(this).data('pid');
            let check_element = 'pid-' + parameters.virtuemart_order_id + '_' + parameters.virtuemart_product_id;
            parameters.quantity = $('#' + check_element).data('quantity');
            parameters.package_id = $("#package_id-" + parameters.virtuemart_order_id + '_' + parameters.virtuemart_product_id).val();
            const ele = document.getElementById(check_element);
            if (ele.checked) {
                pthis.updateProductPackageStatus(parameters, "checked");
                ele.checked = true;
            }
            else {
                pthis.updateProductPackageStatus(parameters, "unchecked");
                ele.checked = false;
            }
        });
    }
    updateProductPackageStatus(parameters, product_package_status) {
        var action_url = 'core/ajax/products_packaging_check.php';
        if (parameters.virtuemart_order_id && parameters.virtuemart_product_id) {
            $.ajax({
                type: 'POST',
                url: action_url,
                data: {
                    button: "updatestatus",
                    virtuemart_order_id: parameters.virtuemart_order_id,
                    virtuemart_product_id: parameters.virtuemart_product_id,
                    quantity: parameters.quantity,
                    package_id: parameters.package_id,
                    product_package_status: product_package_status
                }
            })
                .done(function (response) {
                var jresponse = JSON.parse(response);
                if (jresponse.status.all_checked === "yes") {
                    $('.overlay_task-completed').addClass('active');
                    setTimeout(() => { $('.overlay_task-completed').removeClass('active'); }, 1300);
                }
                // Se tutti i prodotti sono checcati dai conferma visiva              
            })
                .fail(function (response) {
                alert('failed');
            });
        }
    }
}
export class OrdersLabels {
    constructor() {
        this.order_obj = new OrdersManager;
    }
    packageSelector() {
        console.log('packageSelector');
        $(".package-selector").on('change', function () {
            if ($(this).val() == "S") {
                $(this).parent().parent().parent().find(".colli-only").hide();
                $(this).parent().parent().parent().find(".buste-e-colli").removeClass("col-md-2");
                $(this).parent().parent().parent().find(".buste-e-colli").addClass("col-md-4");
                // $(this).parent().parent().find(".width").css("display","none");       
                // $(this).parent().parent().find(".height").css("display","none");                    
            }
            else if ($(this).val() == "C") {
                $(this).parent().parent().parent().find(".colli-only").show();
                $(this).parent().parent().parent().find(".buste-e-colli").removeClass("col-md-4");
                $(this).parent().parent().parent().find(".buste-e-colli").addClass("col-md-2");
                // $(this).parent().parent().show();   
                // $(this).parent().parent().find(".form-control.width").css("display","block");       
                // $(this).parent().parent().find(".form-control.height").css("display","block");                    
            }
        });
    }
    addMorePackages() {
        var self = this;
        $(".add-more-packages").on('click', function (i, el) {
            var orderid = $(this).data('orderid');
            // var p1 = $(this).parent().parent().find(".package-n");
            var number_of_existing_packs = $(this).parent().parent().find(".package-n").length;
            // var orderid = $(this).parent().parent().find(".package-n").eq(0).data("orderid");            
            var pack_n = number_of_existing_packs + 1;
            // Clone first element
            var p1 = $(this).parent().parent().find(".package-n").eq(0).clone(true);
            // Modify data attribute
            $(p1).attr("data-itemn", pack_n);
            $(p1).find(".align-items-center").append('<div class="col-md-1 remove-package">remove</div>');
            // Append to container
            var $container = $(this).parent().parent().find('[id^=dimensions-wrap]');
            $container.append(p1);
            // Riorodino
            self.reorderPackages(orderid);
            self.bindRemovePackage(orderid);
        });
    }
    // Remove package and reorder
    bindRemovePackage(orderid) {
        var self = this;
        $(".remove-package").on('click', function (event) {
            // Rimuovo il nodo
            $(this).parent().parent().remove();
            // Riorodino                                
            self.reorderPackages(orderid);
        });
    }
    reorderPackages(orderid) {
        let $packs_container = $("#dimensions-wrap-" + orderid);
        let number_of_existing_packs = $packs_container.find(".package-n").length;
        $packs_container.find('.package-n').each(function (index, element) {
            let nx = (index + 1).toString();
            $(element).find('.data-item-n-list').html(nx);
            $(element).attr("data-itemn", index);
        });
    }
    /**
     * Crea etichetta nuova
     * Usa come dati di spedizioni quelli dell'ordine
     * in base al orderid (cioe il virtuemart_order_id)
     *  */
    createLabel() {
        let self = this;
        $(".sbuttonlabel").on('click', function (event) {
            let orderid = $(this).data('orderid');
            let courier = $(this).data('courier');
            let action_url = "core/ajax/createLabel.php";
            let message_container = "#order-" + orderid + " .card-footer .message-container";
            let stato_etichetta = "#order-" + orderid + " .stato-etichetta";
            // var tracking = "#order-" + orderid + " .tracking";
            // var buttonid = "#createlabel-" + orderid 
            let buttonid = "#btnGroupCreaEtichetta-" + orderid;
            let parameters = self.order_obj.getPackInfo(orderid, courier);
            // Courier 
            parameters.courier = courier;
            // dropoffpoint
            let dropoffpoint = $("#order-" + orderid + " .dropoff-point").val();
            if (dropoffpoint) {
                parameters.dropoffpoint = dropoffpoint;
            }
            console.log(parameters);
            $.ajax({
                type: 'POST',
                url: action_url,
                data: {
                    button: "submit",
                    orderid: orderid,
                    action: "I",
                    courier: courier,
                    parameters: parameters
                },
                beforeSend: function () {
                    $("#loader-wrap-" + orderid).show();
                }
            })
                .done(function (response) {
                var jresponse = JSON.parse(response);
                console.log(jresponse);
                if (jresponse.status == "success") {
                    $(stato_etichetta).html("Etichetta: generata");
                    $(buttonid).parent().hide();
                    $("#loader-wrap-" + orderid).hide();
                }
                $(message_container).html(jresponse.statusMsg);
            })
                .fail(function (response) {
                alert('failed');
            });
        });
    }
    /**
     * Edita etichetta gia' creata
     * oppure serve per creare nuova etichetta personalizzata,
     * cioe' non usai dati dell'ordine ma i dati inseriti nel form
     *
     * @deprecated Sostituito da editLabelNew
     */
    editLabel() {
        let self = this;
        $(".sbuttonlabelmod").on('click', function (event) {
            var orderid = $(this).data('orderid');
            let courier = $(this).data('courier');
            var action_url = "core/ajax/createLabel.php";
            var message_container = "#order-" + orderid + " .card-footer .message-container";
            var message_container_parsing = "#order-" + orderid + " .message-container-parsing";
            var stato_etichetta = "#order-" + orderid + " .stato-etichetta";
            // var tracking = "#order-" + orderid + " .tracking";
            // var buttonid = "#modifylabel-" + orderid 
            $(message_container_parsing).html("");
            $(message_container).html("");
            var dropoffpoint = $("#order-" + orderid + " .dropoffpoint-point").val();
            var name = $("#order-" + orderid + " .ragione-sociale").val();
            var addrline1 = $("#order-" + orderid + " .addrline1").val();
            var town = $("#order-" + orderid + " .town").val();
            var postcode = $("#order-" + orderid + " .postcode").val();
            var province = $("#order-" + orderid + " .province").val();
            var contactname = $("#order-" + orderid + " .contactname").val();
            var email = $("#order-" + orderid + " .email").val();
            var phone1 = $("#order-" + orderid + " .phone1").val();
            var phone2 = $("#order-" + orderid + " .phone2").val();
            var specialinstructions = $("#order-" + orderid + " .specialinstructions").val();
            let parameters = {};
            // Check parameters           
            var error = 0;
            var status_message = "";
            if (dropoffpoint) {
                parameters.dropoffpoint = dropoffpoint;
            }
            // Courier 
            parameters.courier = courier;
            if (name) {
                if (String(name).length < 50) {
                    parameters.name = name;
                }
                else {
                    error += 1;
                    status_message += " La ragione sociale deve avere meno di 50 caratteri";
                }
            }
            if (addrline1) {
                if (String(addrline1).length < 35) {
                    parameters.addrline1 = addrline1;
                }
                else {
                    error += 1;
                    status_message += " L'indirizzo deve avere meno di 35 caratteri";
                }
            }
            if (town) {
                parameters.town = town;
            }
            if (postcode) {
                var re = new RegExp("^([0-9]+)$");
                if (re.test(postcode)) {
                    parameters.postcode = postcode;
                }
                else {
                    error += 1;
                    status_message += " Formato cap non corretto. Deve essere solo numerico";
                }
            }
            if (province) {
                parameters.province = province;
            }
            if (contactname) {
                parameters.contactname = contactname;
            }
            if (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (re.test(String(email).toLowerCase())) {
                    parameters.email = email;
                }
                else {
                    error += 1;
                    status_message += " Formato email non corretto. Il formato deve essere xxxx@yyyy.it";
                }
            }
            if (phone1) {
                parameters.phone1 = phone1;
            }
            if (phone2) {
                parameters.phone2 = phone2;
            }
            if (specialinstructions) {
                parameters.specialinstructions = specialinstructions;
            }
            // Set pack info
            let package_parameters = self.order_obj.getPackInfo(orderid, courier);
            parameters = Object.assign(Object.assign({}, parameters), package_parameters);
            console.log('Edit label');
            console.log(parameters);
            console.log(error);
            // If errors display 
            if (error) {
                $(message_container_parsing).html(status_message);
            }
            // Submit ajax if no errors
            if (!error) {
                $.ajax({
                    type: 'POST',
                    url: action_url,
                    data: {
                        button: "submit",
                        orderid: orderid,
                        action: "M",
                        courier: courier,
                        parameters: parameters
                    },
                    beforeSend: function () {
                        $("#loader-wrap-" + orderid).show();
                    }
                })
                    .done(function (response) {
                    var jresponse = JSON.parse(response);
                    if (jresponse.status == "success") {
                        $(stato_etichetta).html("Etichetta: modificata");
                        $("#loader-wrap-" + orderid).hide();
                        $(this).hide();
                    }
                    $(message_container).html(jresponse.statusMsg);
                    // $(message_container).html(jresponse.tntReturnXml);                   
                })
                    .fail(function (response) {
                    alert('failed');
                });
            }
        });
    }
    /**
     * Edita etichetta gia' creata oppure serve per creare nuova
     * etichetta personalizzata. Cioe' non usa i dati dell'ordine
     * ma i dati inseriti nel form.
     *
     */
    editLabelNew() {
        let self = this;
        $(".editorcreatelabel").on('click', function (event) {
            $(".invalid-feedback").html("");
            $(".invalid-feedback").hide();
            let formdata = jQuery(".edit-list-form").serializeArray();
            let parameters = {};
            for (var i = 0; i < formdata.length; i++) {
                let key = formdata[i].name.replace('gform-', '');
                parameters[key] = formdata[i].value;
            }
            var orderid = parameters.virtuemart_order_id;
            let courier = $(this).data('courier');
            var action_url = "core/ajax/createLabel.php";
            var message_container = ".card-footer .message-container";
            $(message_container).html("");
            // Check parameters           
            let error = 0;
            let error_message = "";
            if (String(parameters.name).length > 50) {
                error += 1;
                self.showError("gform-name", "La ragione sociale deve avere meno di 50 caratteri");
            }
            else if (!parameters.name) {
                parameters.name = parameters.contactname;
            }
            if (String(parameters.addrline1).length > 35) {
                error += 1;
                self.showError("gform-addrline1", "L'indirizzo deve avere meno di 35 caratteri");
            }
            if (!String(parameters.contactname)) {
                error += 1;
                self.showError("gform-contactname", "Parametro richiesto");
            }
            if (!String(parameters.addrline1)) {
                error += 1;
                self.showError("gform-addrline1", "Parametro richiesto");
            }
            if (!String(parameters.town)) {
                error += 1;
                self.showError("gform-town", "Parametro richiesto");
            }
            if (!String(parameters.postcode)) {
                error += 1;
                self.showError("gform-postcode", "Parametro richiesto");
            }
            if (!String(parameters.province)) {
                error += 1;
                self.showError("gform-province", "Parametro richiesto");
            }
            if (!String(parameters.email)) {
                error += 1;
                self.showError("gform-email", "Parametro richiesto");
            }
            if (!String(parameters.phone1)) {
                error += 1;
                self.showError("gform-phone1", "Parametro richiesto");
            }
            if (!String(parameters.phone2)) {
                error += 1;
                self.showError("gform-phone2", "Parametro richiesto");
            }
            if (parameters.postcode) {
                let postcode = parameters.postcode;
                var re = new RegExp("^([0-9]+)$");
                if (!re.test(postcode)) {
                    error += 1;
                    self.showError("gform-postcode", "Formato cap non corretto. Deve essere solo numerico");
                    error_message = " ";
                }
            }
            if (parameters.phone1) {
                let phone1 = parameters.phone1;
                var re = new RegExp("^([0-9]+)$");
                if (!re.test(phone1)) {
                    error += 1;
                    self.showError("gform-phone1", "Formato Prefisso non corretto. Deve essere solo numerico");
                    error_message = " ";
                }
            }
            if (parameters.phone2) {
                let phone2 = parameters.phone2;
                var re = new RegExp("^([0-9]+)$");
                if (!re.test(phone2)) {
                    error += 1;
                    self.showError("gform-phone2", "Formato Numero tel non corretto. Deve essere solo numerico");
                    error_message = " ";
                }
            }
            if (parameters.email) {
                let email = parameters.email;
                var re = new RegExp("^([0-9]+)$");
                if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
                    error += 1;
                    self.showError("gform-email", "Formato email non corretto.");
                    error_message = " ";
                }
            }
            // Set shipping data
            parameters['shipping_data'] = {};
            parameters['shipping_data']['name'] = parameters.name;
            parameters['shipping_data']['contactname'] = parameters.contactname;
            parameters['shipping_data']['addrline1'] = parameters.addrline1;
            parameters['shipping_data']['town'] = parameters.town;
            parameters['shipping_data']['postcode'] = parameters.postcode;
            parameters['shipping_data']['phone1'] = parameters.phone1;
            parameters['shipping_data']['phone2'] = parameters.phone2;
            parameters['shipping_data']['email'] = parameters.email;
            parameters['shipping_data']['specialinstructions'] = parameters.specialinstructions;
            parameters['shipping_data']['nota_indirizzo'] = parameters.nota_indirizzo;
            // Set courier
            parameters.courier = courier;
            // Set custom flag. Usata per forzare utilizzo di shipping_data esistenti 
            // invece che recuperare gli shipping_data dall'ordine
            // 1 = utilizza shipping_data
            // 0 = non utilizzare shipping_data ma recupera dall'ordine
            parameters.custom = 1;
            // Set pack info
            let package_parameters = self.order_obj.getPackInfo(orderid, courier);
            // Combina i parametri
            parameters = Object.assign(Object.assign({}, parameters), package_parameters);
            console.log(parameters);
            console.log(orderid);
            // Submit ajax if no errors
            if (!error) {
                $.ajax({
                    type: 'POST',
                    url: action_url,
                    data: {
                        button: "submit",
                        orderid: orderid,
                        action: "I",
                        courier: courier,
                        parameters: parameters
                    },
                    beforeSend: function () {
                        $("#loader-wrap-" + orderid).show();
                    }
                })
                    .done(function (response) {
                    var jresponse = JSON.parse(response);
                    console.log(jresponse);
                    if (jresponse.status == "success") {
                        $('[id^=loader-wrap]').hide();
                        $(this).hide();
                    }
                    $(message_container).html(jresponse.statusMsg);
                })
                    .fail(function (response) {
                    alert('Failed. See console');
                    console.log(response);
                });
            }
        });
    }
    showError(intf, error_message) {
        let el = document.getElementById(intf).parentNode;
        el.querySelector(".invalid-feedback").innerHTML = error_message;
        el.querySelector(".invalid-feedback").style.display = "block";
    }
}
